(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ClusterFranchiserFormController', ClusterFranchiserFormController)

    /** @ngInject */
    function ClusterFranchiserFormController($state, $stateParams, HelperService, sweetAlert, ClusterService) {
        const vm = this;
        const clusterId = $stateParams.clusterId;
        let clusterOriginalData = {};

        // SYSTEM DEFAULT METHODS
        // vm.uiCanExit = () => {
        //     return HelperService.uiCanExit(clusterOriginalData, vm.clusterData);
        // }

        // vm.isDataModified = () => {
        //     return !angular.equals(vm.clusterData, clusterOriginalData);
        // }

        // vm.resetForm = () => {
        //     angular.copy(clusterOriginalData, vm.clusterData);
        // }

        vm.saveCluster = () => {
            HelperService.startLoading('.loading-holder');

            if (!vm.clusterData.Id) {
                ClusterService
                    .post(vm.clusterData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                let clusterData = {
                    Id: clusterId,
                    ExternalCode: vm.clusterData.ExternalCode,
                    Description: vm.clusterData.Description
                };

                ClusterService
                    .put(clusterData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteCluster = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    ClusterService
                        .deleteCluster(clusterId)
                        .then(
                            () => {
                                $state.go('app.franchiser-clusters-list')
                                HelperService.stopLoading('.loading-holder');
                                HelperService.successCallback('delete');
                            }, error => {
                                HelperService.errorCallback(error);
                                HelperService.stopLoading('.loading-holder');
                            })
                }
            })
        }

        init();

        function getCluster() {
            if (!clusterId)
                return;

            HelperService.startLoading('.loading-holder');

            ClusterService
                .get(clusterId)
                .then(success => {
                    vm.clusterData = success;
                    clusterOriginalData = angular.copy(vm.clusterData);

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function successCallback(success, isPost) {
            if (isPost) {
                HelperService.successCallback();

                vm.clusterData = success;

                $state.go('app.franchiser-clusters-edit', {
                    clusterId: vm.clusterData.Id
                }, {
                    notify: false
                });
            }

            angular.copy(vm.clusterData, clusterOriginalData);

            HelperService.successCallback('update');
            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function init() {
            vm.clusterData = {};
            getCluster();
        }
    }
}());